export class Padding
{
    private _size: number;
    private _left: number;
    private _right: number;
    private _top: number;
    private _bottom: number;
    private _horizontal: number;
    private _vertical: number;

    public get left(): number { return this._left; }
    public set left(value: number) { this._left = value; }

    public get right(): number { return this._right; }
    public set right(value: number) { this._right = value; }

    public get top(): number { return this._top; }
    public set top(value: number) { this._top = value; }
    
    public get bottom(): number { return this._bottom; }
    public set bottom(value: number) { this._bottom = value; }
    
    public get horizontal(): number { return this._horizontal; }
    public set horizontal(value: number) { this._horizontal = this._left = this._right = value; }
    
    public get vertical(): number { return this._vertical; }
    public set vertical(value: number) { this._vertical = this._top = this._bottom = value; }

    public get size(): number { return this._size; }
    public set size(value: number) { this._size = this._left = this._right = this._top = this._bottom = value; }

    public constructor();
    public constructor(size: number);
    public constructor(horizontal: number, vertical: number);
    public constructor(left: number, right: number, top: number, bottom: number);
    public constructor(a: number = undefined, b: number = undefined, c: number = undefined, d: number = undefined)
    {
        this.Set(a, b, c, d);
    }

    public Set(size: number): void;
    public Set(horizontal: number, vertical: number): void;
    public Set(left: number, right: number, top: number, bottom: number): void;
    public Set(a: number = undefined, b: number = undefined, c: number = undefined, d: number = undefined): void
    {
        if (d == undefined) {
            if (b == undefined) {
                if (a == undefined) {
                    this._size = 
                    this._left = 
                    this._right = 
                    this._top = 
                    this._bottom = 
                    this._horizontal = 
                    this._vertical = 0;
                }
                else {
                    this._size = 
                    this._left = 
                    this._right = 
                    this._top = 
                    this._bottom = 
                    this._horizontal = 
                    this._vertical = a;
                }
            }
            else {
                this._size = (a + b) / 2;
                this._left = 
                this._right = 
                this._horizontal = a;
                this._top = 
                this._bottom = 
                this._vertical = b;
            }
        }
        else {
            this._size = (a + b + c + d) / 4;
            this._left = a;
            this._right = b;
            this._top = c;
            this._bottom = d;
            this._horizontal = (a + b) / 2;
            this._vertical = (c + d) / 2;
        }
    }

    public CopyFrom(anotherPadding: Padding): void
    {
        this.Set(anotherPadding.size);
    }
}